import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";
import { useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import {SERVICE_SPECIFICID} from '../../api/config.mjs'

const AuthenticationModal = ({ isOpen, onClose, onSubmit }) => {
  const [napidLoaded, setNapidLoaded] = useState(false);
  const [allowAccess, setAllowAccess] = useState(false);
  const [token, setToken] = useState(null);
  const userId = useSelector((state) => state.auth.userEmailId);
  const authDetails = useSelector((state) => state.auth);
  const [widgetReference, setWidgetReference] = useState();
  useEffect(() => { }, [authDetails]);
  useEffect(() => {
    if (isOpen) {
      setNapidLoaded(true);
      setTimeout(() => {
        const widget = window.napid.init("napid-app", {
           serviceSpecificId: "8be8946c-fa8e-11f0-bbe1-9200070b5a0f",
          apiKey:"11f0fa8e-8bf9-4201-bbe1-9200070b5a0f",
          //serviceSpecificId: SERVICE_SPECIFICID,

          callback: function (data) {
            if (data.response === "verified") {
              setAllowAccess(true);
              setToken(data.token);
            } else {
              setAllowAccess(false);
              setToken(null);
            }
          },
        });
        setWidgetReference(widget);
      }, 10);

    }
  }, [isOpen]);
  const setName = () => {
    if (widgetReference && userId) {
      console.log("Setting userEmail on widget:", userId);
      widgetReference.setData({ userId });
    } else {
      console.error("WidgetReference is not initialized or userEmail is null.");
    }
  };
  useEffect(() => {
    if (isOpen) {
      setNapidLoaded(true);

      setTimeout(() => {
        if (widgetReference) {
          setName();
        }
      }, 600); // Ensure adequate delay for widget initialization
    }
  }, [isOpen, widgetReference]);

  const handleClose = (event, reason) => {
    if (reason === "backdropClick" || reason === "escapeKeyDown") {
      return;
    }
    onClose();
  };
  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      maxWidth="md" // Changed to "md" for a larger maxWidth
      fullWidth
      PaperProps={{
        sx: {
          width: "550px", // Adjust width as desired
          height: "400px", // Adjust height as desired
        },
      }}>
      <DialogTitle>
        <Typography
          variant="h6"
          style={{ color: "red", marginTop: "80px", fontSize: "25px" }}
          align="center">
          Authenticate yourself
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Box textAlign="center" marginBottom={2}>
          <Typography variant="body1" component="p" marginBottom={3}>
            User id: {userId ? userId : "userEmail"}
          </Typography>
          <div id="napid-app" style={{ marginLeft: "100px" }}></div>
        </Box>
      </DialogContent>
      <DialogActions style={{ justifyContent: "end" }}>
        <Button
          variant="normal"
          color="secondary"
          style={{ color: "red" }}
          onClick={onClose}>
          Cancel
        </Button>
        <Button
          variant="contained" // Use 'contained' for the primary button
          style={{
            marginRight: "10px",
            backgroundColor: allowAccess ? "red" : "#ebe4e4", // Red when enabled, light gray when disabled
            color: allowAccess ? "white" : "gray", // White text when enabled, gray when disabled
            cursor: allowAccess ? "pointer" : "not-allowed", // Change cursor to "not-allowed" when disabled
          }}
          onClick={allowAccess ? onSubmit : undefined} // Use undefined to prevent click when disabled
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AuthenticationModal;
